module.exports = __webpack_public_path__ + "static/media/sun.daafdb1c.svg";